export default "__VITE_ASSET__01b4c836__"